import useSWR from "swr";
import { Wallet } from "lucide-react";
import { swrFetcher, type WalletInfo } from "@/lib/api";
import { formatUsd } from "@/lib/format";

export function CreditIndicator() {
  const { data, error } = useSWR<WalletInfo>("/api/wallet/balance", swrFetcher, {
    refreshInterval: 10000,
  });

  if (error) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-studio-card px-3 py-2 text-xs text-studio-muted">
        <Wallet className="h-3.5 w-3.5" />
        —
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-studio-card px-3 py-2 text-xs text-studio-muted">
        <Wallet className="h-3.5 w-3.5 animate-pulse" />
        Loading…
      </div>
    );
  }

  const available = Number(data.available_usd);
  const charged = Number(data.total_charged_usd);

  return (
    <div className="rounded-lg bg-studio-card px-3 py-2.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Wallet className="h-3.5 w-3.5 text-studio-accent" />
          <span className="text-xs text-studio-muted">USD balance</span>
        </div>
        <span className="font-mono text-sm font-semibold tabular-nums text-studio-ink">{formatUsd(available, { decimals: 2 }) ?? "—"}</span>
      </div>
      <div className="mt-1.5 flex items-center justify-between text-[10px] text-studio-muted">
        <span>Your active jobs: {data.parallel_usage}</span>
        <span>Charged: {formatUsd(charged, { decimals: 2 }) ?? "—"}</span>
      </div>
    </div>
  );
}
